import React, { useId, useState } from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { useQueryClient } from "@tanstack/react-query";

import { Button } from "components/ui/Button";
import { Dialog } from "components/ui/Dialog";
import { DialogFooter } from "components/ui/Dialog/DialogFooter";
import { PatientProfileForm } from "features/patients/components/PatientProfileForm/PatientProfileForm";

import { usePatientMutation } from "../../../../pages/global/PatientPage/hooks/usePatientMutation";

const AddPatientModal = ({ isOpen, onClose, onPatientCreated }) => {
  const queryClient = useQueryClient();
  let tenantVal = useSelector((state) => state.auth.user?.tenant);
  if (!tenantVal) tenantVal = localStorage.getItem("kinesin-tenant");

  const checkedConsentEmail = false;
  const checkedConsentSms = false;
  const checkedConsentPhone = false;

  const [additionalFormData] = useState({
    addressId: "",
    gpName: "",
    gpSurgery: "",
    gpTelephoneNumber: "",
    gpCity: "",
    gpAddressLine1: "",
    gpAddressLine2: "",
    gpAddressLine3: "",
    gpPostCode: "",
    gpHealthMail: "",
    gms: "",
  });

  const formId = useId();

  const patientMutation = usePatientMutation({
    tenantVal,
    patientId: null,
    additionalFormData,
    checkedConsentEmail,
    checkedConsentSms,
    checkedConsentPhone,
    onSuccess: (payload) => {
      toast.success("Patient added successfully");
      queryClient.invalidateQueries({ queryKey: ["paginatedPatients"] });
      queryClient.invalidateQueries({ queryKey: ["myPaginatedPatients"] });
      queryClient.invalidateQueries({ queryKey: ["patientCounts"] });
      onClose();
      if (payload?.patientId != null) {
        onPatientCreated?.(payload.patientId);
      }
    },
  });

  const handleFormSubmit = (data) => {
    patientMutation.mutate(data);
  };

  return (
    <Dialog open={isOpen} onClose={onClose} title="Add patient" width={1200}>
      <PatientProfileForm
        formId={formId}
        onSubmit={handleFormSubmit}
        hideSubmitButton
      />
      <DialogFooter>
        <Button variant="outline" size="large" onClick={onClose}>
          Cancel
        </Button>
        <Button
          type="submit"
          form={formId}
          variant="primary"
          size="large"
          disabled={patientMutation.isPending}
        >
          {patientMutation.isPending ? "Saving..." : "Save"}
        </Button>
      </DialogFooter>
    </Dialog>
  );
};

export { AddPatientModal };
